import React from "react";

/** items: [{ id, label, Icon, badge?: number }] */
export default function ProfileSideNav({ items, active, onSelect }) {
  return (
    <nav className="pf-side" aria-label="Profile sections">
      {items.map(({ id, label, Icon, badge }) => (
        <button
          key={id}
          type="button"
          data-testid={`profile-tab-${id}`}
          aria-current={active === id ? "page" : undefined}
          onClick={() => onSelect(id)}
        >
          <Icon sx={{ fontSize: 18 }} />
          {label}
          {badge ? <span className="n" aria-label={`${badge} need attention`}>{badge}</span> : null}
        </button>
      ))}
    </nav>
  );
}
